<template>
    <div class="tooltip-point" @mouseenter="popoverTrigger" @mouseleave="popoverTrigger">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "BikeTooltip",
    props: {
        placement: {
            default: 'top'
        }
    },
    methods: {
        popoverTrigger(event) {
            if (document.documentElement.clientWidth < 768) {
                if (bootstrap.Popover.getInstance(event.target)) {
                    bootstrap.Popover.getInstance(event.target).toggle();
                } else {
                    new bootstrap.Popover(event.target, {
                        trigger: 'manual',
                        placement: this.placement,
                        container: 'body',
                        html: true,
                        content: event.target.innerHTML
                    }).toggle();
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
